import {NewInputField} from "../components/NewInputField";

export default class HomePage {
    init() {
        const config = {
            addNewInputField: $('.js-new-input-field'),
            addNewTextarea: $('.js-new-textarea')
        };

        let newInputField = new NewInputField(config);
        newInputField.init();
    }
}


// WEBPACK FOOTER //
// ./static/js/pages/TalentForm.js